import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { FileSystemNode } from '../model/FileSystemNode';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  constructor(private http: HttpClient) { }

  getDirectory(dirPath: string): Observable<FileSystemNode> {
    return this.http.get<FileSystemNode>(`${environment.apiUrl}/files/directories`, { params: { dirPath }, withCredentials: true });
  }

  deleteItem(node: FileSystemNode): Observable<FileSystemNode> {

    const body = {
      filePath: node.path
    };

    return this.http.delete<FileSystemNode>(`${environment.apiUrl}/files/item`, {
      body: body,
      withCredentials: true
    });
  }

  createDirectory(dirPath: string): Observable<FileSystemNode> {
    return this.http.post<FileSystemNode>(`${environment.apiUrl}/files/directories`, { dirPath: dirPath }, { withCredentials: true });
  }

}
